import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { useBridgeApi, useI18n, useLogger } from '~Hooks';

const Wrapper = styled.div``;

const Text = styled.div`
  font-size: 24px;
  color: #fff;
  font-weight: 300;
  text-align: center;
`;

const Error = styled.div`
  font-size: 24px;
  color: red;
  font-weight: 300;
  text-align: center;
`;

interface Props {
  submit: (s: string) => void;
}

export const QRScanView = ({ submit }: Props) => {
  const { i18n } = useI18n();
  const bridgeApi = useBridgeApi();

  const [scanning, setScanning] = useState(false);
  const [error, setError] = useState('');
  const logger = useLogger('gift-card-qr-scan');

  const initiateScanning = async () => {
    const scannedCode = await bridgeApi.scanQRCode();
    logger.info('Scanned gift card result', { scannedCode });
    if (scannedCode) {
      submit(scannedCode);
    } else {
      setError(i18n('GC.InvalidScan'));
    }
    setScanning(false);
  };

  useEffect(() => {
    setScanning(true);
    initiateScanning();
  }, []);

  return (
    <Wrapper>
      {scanning && <Text>{i18n('GC.Scanning')}</Text>}
      {error && <Error>{error}</Error>}
    </Wrapper>
  );
};
